<template>
  <div class="countries">
    <page-header title="Countries" icon="globe">
      <div slot="sub-title">
        Country management
      </div>
      <div slot="controls">
        <el-button type="primary" icon="el-icon-plus" @click="showDialog = true" plain>Add country</el-button>
      </div>
    </page-header>

    <el-row :gutter="20" class="body-padding">
      <el-col :span="24" v-loading="loading">
        <el-table :data="countries" v-if="!loading">
          <el-table-column
            label="-"
            width="50">
            <template slot-scope="scope">
              <table-control icon="el-icon-close" :obj="scope.row" @action="removeCountry" />          
            </template>
          </el-table-column>
          <el-table-column label="Name" prop="name" />
          <el-table-column label="Base currency" prop="currency.name" />
          <el-table-column
            fixed="right"
            width="240">
              <template slot-scope="scope">
                <table-control
                  icon="el-icon-edit"
                  :obj="scope.row"
                  dialogTitle="Edit user"
                  @update="update"
                  dialogWidth="400px"
                  dialog-padding>
                  <template slot-scope="slotProps">
                    <upsert-form :country="slotProps.obj" @update="slotProps.update" />
                  </template>
                </table-control>
              </template>
            </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog :append-to-body="true" append-to-body width="400px" title="Add country" :visible.sync="showDialog">
      <upsert-form v-if="showDialog" @add="addCountry" />
    </el-dialog>

  </div>
</template>

<script>
import UpsertForm from './UpsertForm'
import TableControl from '@/components/shared/TableControls'

export default {
  name: 'Countries',
  components: { UpsertForm, TableControl },
  data () {
    return {
      showDialog: false,
      loaded: false,
      countries: []
    }
  },
  methods: {
    addCountry (country) {
      this.countries.unshift(country)
      this.showDialog = false
    },
    update (country, updated) {
      const index = this.countries.indexOf(country)
      this.countries[index].name = updated.name
      this.countries[index].currency = updated.currency
    },
    async removeCountry (country) {
      const response = await this.$http.delete(this.$api.countries.delete(country.id))
      this.countries.splice(this.countries.indexOf(country), 1)
    },
    async getCountries () {
      const response = await this.$http.get(this.$api.countries.index)
      this.countries = response.data
      this.loaded = true
    }
  },
  created () {
    this.getCountries()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/countries/Countries.vue